import {isAbortError} from '@raison/network-facade';
import {GenericErrorMsg} from '~/entities/dialogs';
import {useAppDispatch} from '~/shared/store';

export function useErrorHandler() {
    const dispatch = useAppDispatch();
    return (error: unknown): never => {
        if (!isAbortError(error)) {
            dispatch(GenericErrorMsg.open());
        }
        throw error;
    };
}
